/**
 * Swedish member UI bundle. Finnish remains the source of truth for message
 * keys and supplies the deliberately Finnish-only admin chrome. The member
 * fragments below override the surfaces available to members.
 */

import { fi, type MessageKeys } from './fi.js';
import { commonSv } from './sv/common.js';
import { homeSv } from './sv/home.js';
import { memberSv } from './sv/member.js';
import { memberMessagingCatalogueSv } from './sv/memberMessagingCatalogue.js';
import { memberMessagingComposeSv } from './sv/memberMessagingCompose.js';
import { myCasesSv } from './sv/myCases.js';
import { myDataDeletionSv } from './sv/myDataDeletion.js';
import { myDataExportSv } from './sv/myDataExport.js';
import { onboardingSv } from './sv/onboarding.js';
import { shellSv } from './sv/shell.js';

export const sv: Record<MessageKeys, string> = {
  ...fi,
  ...commonSv,
  ...homeSv,
  ...shellSv,
  ...memberSv,
  ...memberMessagingComposeSv,
  ...myCasesSv,
  ...myDataDeletionSv,
  ...myDataExportSv,
  ...memberMessagingCatalogueSv,
  ...onboardingSv,
};
